export default function TrustBadges() {
  const badges = [
    {
      icon: 'ri-scissors-cut-line',
      label: 'Laser Cut',
      description: 'Precision cut designs',
    },
    {
      icon: 'ri-shield-check-line',
      label: 'Stainless Steel',
      description: 'Rustproof & durable',
    },
    {
      icon: 'ri-grid-line',
      label: '70+ Designs',
      description: 'Find your perfect match',
    },
    {
      icon: 'ri-truck-line',
      label: 'Ships from the US',
      description: 'Fast domestic shipping',
    },
  ];

  return (
    <section className="bg-[#fcfcfc] py-10 md:py-12">
      <div className="container-main">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {badges.map((badge) => (
            <div key={badge.label} className="text-center">
              <div className="w-8 h-8 mx-auto mb-3 flex items-center justify-center text-[#2c2a4a] bg-[#2c2a4a]/10 rounded">
                <i className={`${badge.icon} text-lg`} />
              </div>
              <h4 className="text-base md:text-lg font-sans font-semibold text-[#2c2a4a] mb-1">
                {badge.label}
              </h4>
              <p className="text-sm md:text-base font-sans text-[#2c2a4a]/60">
                {badge.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}